import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetResourceCategories = () => {
  const get = useTypedApiClient({
    path: '/le-connect/resources/categories',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/le-connect/resources/categories'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
